import { Rive, RuntimeLoader } from '@rive-app/canvas';

import riveWASMResource from '@rive-app/canvas/rive.wasm?url';
RuntimeLoader.setWasmUrl(riveWASMResource);

export default function createRive(
  canvas,
  container,
  stateMachinesName = 'ep240k',
  options = {}
) {
  if (!canvas) return null;

  let cases;
  let inputs;
  let state;
  let hoverElements;

  if (container) {
    hoverElements = container.querySelectorAll('.w-highlight');
    if (hoverElements.length > 0) {
      hoverElements = Array.from(hoverElements).sort((a, b) => {
        const orderA = parseInt(a.getAttribute('data-w-order'));
        const orderB = parseInt(b.getAttribute('data-w-order'));
        return orderA - orderB;
      });
    }
  }

  const src = canvas.getAttribute('data-w-rive');
  const artboard = canvas.getAttribute('data-w-artboard');

  const r = new Rive({
    canvas,
    src,
    artboard: artboard,
    autoplay: false,
    stateMachines: stateMachinesName,
    onStateChange: (animation) => {
      state = animation.data[0];

      if (hoverElements.length > 0) {
        if (state === 'idle' || state.startsWith('active_')) {
          hoverElements.forEach((child) => {
            child.classList.remove('w-is-active');
          });
        }
        if (cases.includes(state) && hoverElements[cases.indexOf(state)]) {
          hoverElements[cases.indexOf(state)].classList.add('w-is-active');
        }
      }
    },
    onLoad: () => {
      cases = r.animationNames.filter((name) => name.startsWith('active_'));
      inputs = r.stateMachineInputs(stateMachinesName);

      if (hoverElements.length > 0) {
        hoverElements.forEach((child, index) => {
          child.addEventListener('mouseenter', (e) => {
            const element = inputs.find((i) => i.name === cases[index]);
            if (element) element.value = true;
          });

          child.addEventListener('mouseleave', (e) => {
            const element = inputs.find((i) => i.name === cases[index]);
            if (element) element.value = false;
          });
        });
      }

      if (options?.callback) options.callback(r);

      r.resizeDrawingSurfaceToCanvas();
      r.stopRendering(); // does this improve performance?
    },
  });

  return {
    r,
    canvas,
    artboard,
    inputs,
  };
}
